import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      videos: this.el.querySelectorAll('.video-hero-v2__video'),
      playButton: this.el.querySelector('.video-hero-v2__play-button'),
      pauseButton: this.el.querySelector('.video-hero-v2__pause-button')
    };
  }

  addListeners() {
    this.dom.playButton.addEventListener('click', ::this.playVideo);
    this.dom.pauseButton.addEventListener('click', ::this.pauseVideo);
  }

  playVideo(event) {
    this.dom.playButton.style.display = 'none';
    this.dom.pauseButton.style.display = 'block';
    this.dom.videos.forEach(video => {
      video.play();
    });

    if (event && (event.type === 'click' || event.type === 'focus')) {
      this.dom.pauseButton.focus();
    }
  }

  pauseVideo(event) {
    this.dom.playButton.style.display = 'block';
    this.dom.pauseButton.style.display = 'none';
    this.dom.videos.forEach(video => {
      video.pause();
    });

    if (event && (event.type === 'click' || event.type === 'focus')) {
      this.dom.playButton.focus();
    }
  }
}

export default Module;
